import type { KentuckyPlugin } from "@leapfinancial/kentucky-sdk";
import { safeCapture, safeRegister } from "./posthog";

/**
 * Forwards Kentucky SDK telemetry to the host flow's PostHog client.
 * Does not init PostHog or call identify — preserves session + distinct_id.
 *
 * Note: KentuckyPlugin (sdk ≤1.0.11) exposes captureEvent only; exception
 * forwarding lands when the SDK adds captureException to the plugin type.
 */
export function createKentuckyPostHogBridge(): KentuckyPlugin {
  return {
    name: "host-posthog",

    captureEvent: (eventName, properties) => {
      safeCapture(eventName, {
        ...properties,
        service: "kentucky-sdk",
      });
    },

    onTicketClaimed: (ticket) => {
      // KYC context as super-properties — do not change distinct_id.
      safeRegister({
        kyc_ticket_id: ticket.id,
        kyc_reference_id: ticket.referenceId,
        kyc_flow: ticket.flow,
      });
    },
  };
}
